import React, { useState } from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';
import Image from '../elements/Image';
import Modal from '../elements/Modal';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  }   

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',

  );



  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <h1 className="mt-0 mb-16 mt-997 reveal-from-bottom" data-reveal-delay="200">
              <span className="text-color-primary">Tokenize</span> your work
            </h1>
            <h2 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">
              On the most complete <span className="text-color-primary">DeMI</span> ecosystem
              
            </h2>
            <br></br>
                <div className="container-xs">
              <div className="reveal-from-bottom" data-reveal-delay="600">
                <ButtonGroup>
                  <Button tag="a" color="primary" wideMobile href="https://medium.com/@noteblock.contact">
                    Medium Blogs
                    </Button>
                  {/*<Button tag="a" color="dark" wideMobile href="https://github.com/cruip/open-react-template/">
                    View on Github
                  </Button>*/}
                  <Button tag="a" color="dark" wideMobile href="https://github.com/">
                    View Github Repo
                  </Button>
                </ButtonGroup>
              </div>
            </div>
          </div>
          <div className="hero-figure reveal-from-bottom illustration-element-01" data-reveal-value="20px" data-reveal-delay="800">
            {/*<a
              data-video="https://player.vimeo.com/video/174002812"
              href="#0"
              aria-controls="video-modal"
              onClick={openModal}
            >*/}
              <Image
                className=""
                src={require('./../../assets/images/producer_studio.png')}
                alt="Hero"
                width={896}
                height={504} />
            {/*</a>*/}
          </div>

            
          <div className="mt-999">
              <p className=" reveal-from-bottom" data-reveal-delay="400">
              NoteBlock is the Music Industry on Ethereum, and so much more!
                </p>
              <h3>
                <span className="text-color-secondary">
                  With built-in charitable donations to:
                </span>
              </h3>
              <h5>
                <span className="text-color-secondary">
                    Support diversity causes
                </span>
              </h5>
              <h5>
                <span className="text-color-secondary">
                    Bring equality to the Music Industry
                </span>
              </h5>
              <h5>
                <span className="text-color-secondary">
                    Make a difference
                </span>
              </h5>
            </div>

          {/*<Modal
            id="video-modal"
            show={videoModalActive}
            handleClose={closeModal}
            video="https://player.vimeo.com/video/174002812"
          videoTag="iframe" />*/}
        </div>
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;